import React from 'react';
import { Logo } from '../components/Logo';
import { ArrowLeftIcon } from 'lucide-react';
export function BrandBook() {
  const blues = [{
    name: 'blue-200',
    hex: '#BFDBFE',
    class: 'bg-blue-200'
  }, {
    name: 'blue-300',
    hex: '#93C5FD',
    class: 'bg-blue-300'
  }, {
    name: 'blue-400',
    hex: '#60A5FA',
    class: 'bg-blue-400'
  }, {
    name: 'blue-500',
    hex: '#3B82F6',
    class: 'bg-blue-500'
  }, {
    name: 'blue-600',
    hex: '#2563EB',
    class: 'bg-blue-600'
  }];
  const grays = [{
    name: 'gray-900',
    hex: '#111827',
    class: 'bg-gray-900'
  }, {
    name: 'gray-700',
    hex: '#374151',
    class: 'bg-gray-700'
  }, {
    name: 'gray-600',
    hex: '#4B5563',
    class: 'bg-gray-600'
  }, {
    name: 'gray-500',
    hex: '#6B7280',
    class: 'bg-gray-500'
  }, {
    name: 'gray-400',
    hex: '#9CA3AF',
    class: 'bg-gray-400'
  }, {
    name: 'gray-200',
    hex: '#E5E7EB',
    class: 'bg-gray-200'
  }, {
    name: 'gray-100',
    hex: '#F3F4F6',
    class: 'bg-gray-100'
  }];
  return <div className="min-h-screen bg-gray-50" data-id="element-337">
      {/* Header */}
      <header className="sticky top-0 z-10 bg-white border-b border-gray-200" data-id="element-338">
        <div className="max-w-5xl mx-auto px-6 py-4 flex items-center justify-between" data-id="element-339">
          <div className="flex items-center gap-3" data-id="element-340">
            <Logo showText={false} size="sm" data-id="element-341" />
            <span className="text-sm font-medium text-gray-900" data-id="element-342">
              Obra Digital — Brand Book
            </span>
          </div>
          <a href="#" onClick={e => {
          e.preventDefault();
          window.location.hash = '';
          window.location.reload();
        }} className="flex items-center gap-1.5 text-sm text-gray-500 hover:text-gray-900 transition-colors" data-id="element-343">
            <ArrowLeftIcon className="w-4 h-4" data-id="element-344" />
            Volver al sitio
          </a>
        </div>
      </header>

      <main className="max-w-5xl mx-auto px-6 py-12 space-y-16" data-id="element-345">
        {/* Logo Section */}
        <section data-id="element-346">
          <h2 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-347">Logo</h2>
          <p className="text-sm text-gray-500 mb-8" data-id="element-348">
            Versiones del logo para diferentes contextos.
          </p>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8" data-id="element-349">
            {/* Logo on white */}
            <div className="bg-white rounded-2xl border border-gray-200 p-10 flex items-center justify-center" data-id="element-350">
              <Logo showText={true} size="lg" variant="dark" data-id="element-351" />
            </div>
            {/* Logo on dark */}
            <div className="bg-[#111827] rounded-2xl p-10 flex items-center justify-center" data-id="element-352">
              <Logo showText={true} size="lg" variant="light" data-id="element-353" />
            </div>
            {/* Isotipo on white */}
            <div className="bg-white rounded-2xl border border-gray-200 p-10 flex items-center justify-center" data-id="element-354">
              <Logo showText={false} size="lg" variant="dark" data-id="element-355" />
            </div>
            {/* Isotipo on dark */}
            <div className="bg-[#111827] rounded-2xl p-10 flex items-center justify-center" data-id="element-356">
              <Logo showText={false} size="lg" variant="light" data-id="element-357" />
            </div>
          </div>

          {/* Size variants */}
          <div className="bg-white rounded-2xl border border-gray-200 p-8" data-id="element-358">
            <p className="text-xs font-medium text-gray-400 uppercase tracking-wider mb-6" data-id="element-359">
              Tamaños
            </p>
            <div className="flex items-end gap-10" data-id="element-360">
              <div className="text-center" data-id="element-361">
                <Logo showText={true} size="sm" variant="dark" data-id="element-362" />
                <span className="text-xs text-gray-400 mt-3 block" data-id="element-363">sm</span>
              </div>
              <div className="text-center" data-id="element-364">
                <Logo showText={true} size="md" variant="dark" data-id="element-365" />
                <span className="text-xs text-gray-400 mt-3 block" data-id="element-366">md</span>
              </div>
              <div className="text-center" data-id="element-367">
                <Logo showText={true} size="lg" variant="dark" data-id="element-368" />
                <span className="text-xs text-gray-400 mt-3 block" data-id="element-369">lg</span>
              </div>
            </div>
          </div>

          <div className="mt-6 grid grid-cols-2 gap-4 text-sm text-gray-500" data-id="element-370">
            <div className="bg-white rounded-lg border border-gray-200 p-4" data-id="element-371">
              <span className="font-medium text-gray-700" data-id="element-372">Espacio mínimo</span>
              <p className="text-xs mt-1" data-id="element-373">
                Mantener al menos 1x el ancho del isotipo como margen.
              </p>
            </div>
            <div className="bg-white rounded-lg border border-gray-200 p-4" data-id="element-374">
              <span className="font-medium text-gray-700" data-id="element-375">No distorsionar</span>
              <p className="text-xs mt-1" data-id="element-376">
                Nunca estirar, rotar o cambiar los colores del logo.
              </p>
            </div>
          </div>
        </section>

        <hr className="border-gray-200" data-id="element-377" />

        {/* Color Palette */}
        <section data-id="element-378">
          <h2 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-379">Colores</h2>
          <p className="text-sm text-gray-500 mb-8" data-id="element-380">
            Paleta de colores de la marca.
          </p>

          {/* Primary */}
          <div className="mb-8" data-id="element-381">
            <p className="text-xs font-medium text-gray-400 uppercase tracking-wider mb-4" data-id="element-382">
              Primario
            </p>
            <div className="flex items-start gap-4" data-id="element-383">
              <div className="w-24 h-24 rounded-xl bg-blue-600 shadow-sm" data-id="element-384" />
              <div data-id="element-385">
                <p className="font-semibold text-gray-900" data-id="element-386">Blue 600</p>
                <p className="text-sm text-gray-500 font-mono" data-id="element-387">#2563EB</p>
                <p className="text-xs text-gray-400 mt-1" data-id="element-388">bg-blue-600</p>
              </div>
            </div>
          </div>

          {/* Blue scale */}
          <div className="mb-8" data-id="element-389">
            <p className="text-xs font-medium text-gray-400 uppercase tracking-wider mb-4" data-id="element-390">
              Escala de azules
            </p>
            <div className="flex gap-3" data-id="element-391">
              {blues.map(color => <div key={color.name} className="text-center" data-id="element-392">
                  <div className={`w-14 h-14 rounded-lg ${color.class} shadow-sm`} data-id="element-393" />
                  <p className="text-[10px] text-gray-500 mt-2 font-mono" data-id="element-394">
                    {color.hex}
                  </p>
                  <p className="text-[10px] text-gray-400" data-id="element-395">{color.name}</p>
                </div>)}
            </div>
          </div>

          {/* Gray scale */}
          <div className="mb-8" data-id="element-396">
            <p className="text-xs font-medium text-gray-400 uppercase tracking-wider mb-4" data-id="element-397">
              Escala de grises
            </p>
            <div className="flex gap-3" data-id="element-398">
              {grays.map(color => <div key={color.name} className="text-center" data-id="element-399">
                  <div className={`w-14 h-14 rounded-lg ${color.class} shadow-sm border border-gray-200`} data-id="element-400" />
                  <p className="text-[10px] text-gray-500 mt-2 font-mono" data-id="element-401">
                    {color.hex}
                  </p>
                  <p className="text-[10px] text-gray-400" data-id="element-402">{color.name}</p>
                </div>)}
            </div>
          </div>

          {/* Dark background */}
          <div data-id="element-403">
            <p className="text-xs font-medium text-gray-400 uppercase tracking-wider mb-4" data-id="element-404">
              Fondo oscuro
            </p>
            <div className="flex items-start gap-4" data-id="element-405">
              <div className="w-24 h-24 rounded-xl bg-[#111827] shadow-sm" data-id="element-406" />
              <div data-id="element-407">
                <p className="font-semibold text-gray-900" data-id="element-408">Dark</p>
                <p className="text-sm text-gray-500 font-mono" data-id="element-409">#111827</p>
                <p className="text-xs text-gray-400 mt-1" data-id="element-410">bg-[#111827]</p>
              </div>
            </div>
          </div>
        </section>

        <hr className="border-gray-200" data-id="element-411" />

        {/* Typography */}
        <section data-id="element-412">
          <h2 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-413">Tipografía</h2>
          <p className="text-sm text-gray-500 mb-8" data-id="element-414">
            Inter — La fuente principal de la marca.
          </p>

          <div className="bg-white rounded-2xl border border-gray-200 p-8 space-y-6" data-id="element-415">
            <div data-id="element-416">
              <span className="text-xs text-gray-400 block mb-2" data-id="element-417">
                H1 — text-4xl font-extrabold
              </span>
              <h1 className="text-4xl font-extrabold text-gray-900" data-id="element-418">
                Nunca más pierdas registro
              </h1>
            </div>
            <div data-id="element-419">
              <span className="text-xs text-gray-400 block mb-2" data-id="element-420">
                H2 — text-3xl font-bold
              </span>
              <h2 className="text-3xl font-bold text-gray-900" data-id="element-421">
                Precio simple y transparente
              </h2>
            </div>
            <div data-id="element-422">
              <span className="text-xs text-gray-400 block mb-2" data-id="element-423">
                H3 — text-2xl font-bold
              </span>
              <h3 className="text-2xl font-bold text-gray-900" data-id="element-424">
                El caos de la información
              </h3>
            </div>
            <div data-id="element-425">
              <span className="text-xs text-gray-400 block mb-2" data-id="element-426">
                H4 — text-xl font-semibold
              </span>
              <h4 className="text-xl font-semibold text-gray-900" data-id="element-427">
                Así de simple
              </h4>
            </div>
            <hr className="border-gray-100" data-id="element-428" />
            <div data-id="element-429">
              <span className="text-xs text-gray-400 block mb-2" data-id="element-430">
                Body — text-base text-gray-600
              </span>
              <p className="text-base text-gray-600" data-id="element-431">
                Centraliza todas las fotos de obra automáticamente desde
                WhatsApp. Sin apps nuevas, sin fricción.
              </p>
            </div>
            <div data-id="element-432">
              <span className="text-xs text-gray-400 block mb-2" data-id="element-433">
                Small — text-sm text-gray-500
              </span>
              <p className="text-sm text-gray-500" data-id="element-434">
                Menos del 0,1% del presupuesto total de una obra promedio.
              </p>
            </div>
            <div data-id="element-435">
              <span className="text-xs text-gray-400 block mb-2" data-id="element-436">
                Caption — text-xs text-gray-400
              </span>
              <p className="text-xs text-gray-400" data-id="element-437">
                © 2026 Obra Digital. Todos los derechos reservados.
              </p>
            </div>
          </div>

          {/* Font weights */}
          <div className="mt-6 bg-white rounded-2xl border border-gray-200 p-8" data-id="element-438">
            <p className="text-xs font-medium text-gray-400 uppercase tracking-wider mb-6" data-id="element-439">
              Pesos de fuente
            </p>
            <div className="space-y-4" data-id="element-440">
              <div className="flex items-baseline gap-4" data-id="element-441">
                <span className="w-24 text-xs text-gray-400" data-id="element-442">400 Regular</span>
                <span className="font-normal text-gray-900" data-id="element-443">Obra Digital</span>
              </div>
              <div className="flex items-baseline gap-4" data-id="element-444">
                <span className="w-24 text-xs text-gray-400" data-id="element-445">500 Medium</span>
                <span className="font-medium text-gray-900" data-id="element-446">Obra Digital</span>
              </div>
              <div className="flex items-baseline gap-4" data-id="element-447">
                <span className="w-24 text-xs text-gray-400" data-id="element-448">600 Semibold</span>
                <span className="font-semibold text-gray-900" data-id="element-449">
                  Obra Digital
                </span>
              </div>
              <div className="flex items-baseline gap-4" data-id="element-450">
                <span className="w-24 text-xs text-gray-400" data-id="element-451">700 Bold</span>
                <span className="font-bold text-gray-900" data-id="element-452">Obra Digital</span>
              </div>
              <div className="flex items-baseline gap-4" data-id="element-453">
                <span className="w-24 text-xs text-gray-400" data-id="element-454">
                  800 Extrabold
                </span>
                <span className="font-extrabold text-gray-900" data-id="element-455">
                  Obra Digital
                </span>
              </div>
            </div>
          </div>
        </section>

        <hr className="border-gray-200" data-id="element-456" />

        {/* Buttons */}
        <section data-id="element-457">
          <h2 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-458">Botones</h2>
          <p className="text-sm text-gray-500 mb-8" data-id="element-459">
            Estilos de botones utilizados en la marca.
          </p>

          <div className="bg-white rounded-2xl border border-gray-200 p-8 space-y-8" data-id="element-460">
            {/* Primary */}
            <div data-id="element-461">
              <p className="text-xs font-medium text-gray-400 uppercase tracking-wider mb-4" data-id="element-462">
                Primario
              </p>
              <div className="flex items-center gap-4" data-id="element-463">
                <button className="px-4 py-2 text-sm font-semibold text-white bg-blue-600 hover:bg-blue-700 rounded-xl transition-colors" data-id="element-464">
                  Pequeño
                </button>
                <button className="px-5 py-2.5 text-base font-semibold text-white bg-blue-600 hover:bg-blue-700 rounded-xl transition-colors" data-id="element-465">
                  Mediano
                </button>
                <button className="px-6 py-3 text-lg font-semibold text-white bg-blue-600 hover:bg-blue-700 rounded-xl transition-colors" data-id="element-466">
                  Grande
                </button>
              </div>
              <p className="text-xs text-gray-400 mt-3 font-mono" data-id="element-467">
                bg-blue-600 text-white rounded-xl
              </p>
            </div>

            {/* Secondary */}
            <div data-id="element-468">
              <p className="text-xs font-medium text-gray-400 uppercase tracking-wider mb-4" data-id="element-469">
                Secundario
              </p>
              <div className="flex items-center gap-4" data-id="element-470">
                <button className="px-4 py-2 text-sm font-semibold text-gray-700 bg-white border border-gray-300 hover:bg-gray-50 rounded-xl transition-colors" data-id="element-471">
                  Pequeño
                </button>
                <button className="px-5 py-2.5 text-base font-semibold text-gray-700 bg-white border border-gray-300 hover:bg-gray-50 rounded-xl transition-colors" data-id="element-472">
                  Mediano
                </button>
                <button className="px-6 py-3 text-lg font-semibold text-gray-700 bg-white border border-gray-300 hover:bg-gray-50 rounded-xl transition-colors" data-id="element-473">
                  Grande
                </button>
              </div>
              <p className="text-xs text-gray-400 mt-3 font-mono" data-id="element-474">
                border border-gray-300 text-gray-700 bg-white rounded-xl
              </p>
            </div>

            {/* Ghost */}
            <div data-id="element-475">
              <p className="text-xs font-medium text-gray-400 uppercase tracking-wider mb-4" data-id="element-476">
                Ghost / Texto
              </p>
              <div className="flex items-center gap-4" data-id="element-477">
                <button className="text-sm font-semibold text-blue-600 hover:text-blue-700 transition-colors" data-id="element-478">
                  Enlace de texto
                </button>
              </div>
              <p className="text-xs text-gray-400 mt-3 font-mono" data-id="element-479">
                text-blue-600 hover:text-blue-700
              </p>
            </div>
          </div>
        </section>

        <hr className="border-gray-200" data-id="element-480" />

        {/* Text Colors */}
        <section data-id="element-481">
          <h2 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-482">
            Grises de texto
          </h2>
          <p className="text-sm text-gray-500 mb-8" data-id="element-483">
            Colores de texto para diferentes jerarquías.
          </p>

          <div className="bg-white rounded-2xl border border-gray-200 p-8 space-y-6" data-id="element-484">
            <div data-id="element-485">
              <span className="text-xs text-gray-400 block mb-1" data-id="element-486">
                text-gray-900
              </span>
              <p className="text-gray-900" data-id="element-487">
                Texto principal, títulos y encabezados importantes.
              </p>
            </div>
            <div data-id="element-488">
              <span className="text-xs text-gray-400 block mb-1" data-id="element-489">
                text-gray-700
              </span>
              <p className="text-gray-700" data-id="element-490">
                Texto secundario con buena legibilidad.
              </p>
            </div>
            <div data-id="element-491">
              <span className="text-xs text-gray-400 block mb-1" data-id="element-492">
                text-gray-600
              </span>
              <p className="text-gray-600" data-id="element-493">
                Texto de cuerpo estándar para párrafos.
              </p>
            </div>
            <div data-id="element-494">
              <span className="text-xs text-gray-400 block mb-1" data-id="element-495">
                text-gray-500
              </span>
              <p className="text-gray-500" data-id="element-496">
                Texto de apoyo y descripciones secundarias.
              </p>
            </div>
            <div data-id="element-497">
              <span className="text-xs text-gray-400 block mb-1" data-id="element-498">
                text-gray-400
              </span>
              <p className="text-gray-400" data-id="element-499">
                Texto sutil, captions y metadatos.
              </p>
            </div>
          </div>
        </section>

        <hr className="border-gray-200" data-id="element-500" />

        {/* Spacing & Radius */}
        <section data-id="element-501">
          <h2 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-502">
            Espaciado y Bordes
          </h2>
          <p className="text-sm text-gray-500 mb-8" data-id="element-503">
            Valores de espaciado y radio de borde comunes.
          </p>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-504">
            {/* Border radius */}
            <div className="bg-white rounded-2xl border border-gray-200 p-8" data-id="element-505">
              <p className="text-xs font-medium text-gray-400 uppercase tracking-wider mb-6" data-id="element-506">
                Border Radius
              </p>
              <div className="flex items-end gap-4" data-id="element-507">
                <div className="text-center" data-id="element-508">
                  <div className="w-12 h-12 bg-blue-100 rounded-md" data-id="element-509" />
                  <span className="text-[10px] text-gray-400 mt-2 block" data-id="element-510">
                    rounded-md
                  </span>
                </div>
                <div className="text-center" data-id="element-511">
                  <div className="w-12 h-12 bg-blue-100 rounded-lg" data-id="element-512" />
                  <span className="text-[10px] text-gray-400 mt-2 block" data-id="element-513">
                    rounded-lg
                  </span>
                </div>
                <div className="text-center" data-id="element-514">
                  <div className="w-12 h-12 bg-blue-100 rounded-xl" data-id="element-515" />
                  <span className="text-[10px] text-gray-400 mt-2 block" data-id="element-516">
                    rounded-xl
                  </span>
                </div>
                <div className="text-center" data-id="element-517">
                  <div className="w-12 h-12 bg-blue-100 rounded-2xl" data-id="element-518" />
                  <span className="text-[10px] text-gray-400 mt-2 block" data-id="element-519">
                    rounded-2xl
                  </span>
                </div>
                <div className="text-center" data-id="element-520">
                  <div className="w-12 h-12 bg-blue-100 rounded-full" data-id="element-521" />
                  <span className="text-[10px] text-gray-400 mt-2 block" data-id="element-522">
                    rounded-full
                  </span>
                </div>
              </div>
            </div>

            {/* Spacing */}
            <div className="bg-white rounded-2xl border border-gray-200 p-8" data-id="element-523">
              <p className="text-xs font-medium text-gray-400 uppercase tracking-wider mb-6" data-id="element-524">
                Padding
              </p>
              <div className="space-y-3" data-id="element-525">
                <div className="flex items-center gap-3" data-id="element-526">
                  <div className="bg-blue-600 p-2 rounded" data-id="element-527">
                    <div className="w-4 h-4 bg-white rounded-sm" data-id="element-528" />
                  </div>
                  <span className="text-xs text-gray-500" data-id="element-529">p-2 (8px)</span>
                </div>
                <div className="flex items-center gap-3" data-id="element-530">
                  <div className="bg-blue-600 p-4 rounded" data-id="element-531">
                    <div className="w-4 h-4 bg-white rounded-sm" data-id="element-532" />
                  </div>
                  <span className="text-xs text-gray-500" data-id="element-533">p-4 (16px)</span>
                </div>
                <div className="flex items-center gap-3" data-id="element-534">
                  <div className="bg-blue-600 p-6 rounded" data-id="element-535">
                    <div className="w-4 h-4 bg-white rounded-sm" data-id="element-536" />
                  </div>
                  <span className="text-xs text-gray-500" data-id="element-537">p-6 (24px)</span>
                </div>
                <div className="flex items-center gap-3" data-id="element-538">
                  <div className="bg-blue-600 p-8 rounded" data-id="element-539">
                    <div className="w-4 h-4 bg-white rounded-sm" data-id="element-540" />
                  </div>
                  <span className="text-xs text-gray-500" data-id="element-541">p-8 (32px)</span>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Footer */}
        <div className="text-center pt-8 pb-4" data-id="element-542">
          <p className="text-xs text-gray-400" data-id="element-543">
            Obra Digital Brand Book — Uso interno
          </p>
        </div>
      </main>
    </div>;
}